export const environment = {
  production: true,
  apiEndpoint: 'https://web.yoggl.de'
};
